module.exports = __webpack_public_path__ + "static/scale-model-of-tree-that-owns-itself-in-athens-georgia-46f0ea1a6498dc9d46ad0f52515f6d84.png";